import React from 'react';
import { useSelector } from 'react-redux';
import { State } from '../../../reducers';
import { useSensorData } from '../../../contexts/SensorDataContext';
import './PulledWeight.css'

interface PulledWeightProps {
    pulledWeight?: number | "Out"; // Made optional since we'll use context data
}

export const PulledWeight = (props: PulledWeightProps) => {
    const weightUnit = useSelector((state:State) => state.authentication.user.displaySettings.weightUnit);
    const activityStatus = useSelector((state:State) => state.activities.activityStatus);
    const { processedForce, isDataStreamActive } = useSensorData();
    
    const weightUnitFactor = weightUnit == "kg" ? 1 : 2.2;
    
    // Prefer the prop (set synchronously by ExerciseManager.updateStrength) when provided,
    // fall back to context for pages that render this component without a prop.
    const displayWeight = typeof props.pulledWeight === 'number'
      ? props.pulledWeight
      : (isDataStreamActive ? processedForce : 0);
    
    // Determine if weight should show as "Out" or "MAX"
    const isOut = displayWeight === 'Out' || (typeof displayWeight === 'number' && displayWeight < 0.15) || (!isDataStreamActive && props.pulledWeight === "Out");
    const isMax = displayWeight === 'MAX';

    if (activityStatus) {
        return (
        <div className="strength" style={{ opacity: `${activityStatus == 'rest' ? "0.5" : "1"}` }}>
          {isMax ? (
            <div className='max'>
              MAX
            </div>
          ) : !isOut ? (
            <>
              <div className='strengthNumber'>
                {Math.floor((displayWeight as number) * weightUnitFactor)}.
                {Math.floor(10 * ((displayWeight as number) * weightUnitFactor - Math.floor((displayWeight as number) * weightUnitFactor)))}
              </div>
              <div className='weightUnit'>
                {weightUnit}
              </div>
            </>
          ) : (
            <div className='out'>
              Out
            </div>
          )}
        </div>
      )
    }
    return null;
}